<template>
	<div class="user-center-container">
		<div class="user-center-header filter-container">
			<!-- 搜索条件区域 -->
			<div class="search-container">
				<div class="search-form">
					<div class="form-item">
						<span class="label">订单编号</span>
						<el-input v-model="queryParams.orderCode" placeholder="请输入订单编号" clearable></el-input>
					</div>
					<div class="form-item">
						<span class="label">审核状态</span>
						<el-select v-model="queryParams.publicityStyleStatus" placeholder="请选择审核状态" clearable>
							<el-option label="待审核" :value="0"></el-option>
							<el-option label="审核通过" :value="1"></el-option>
							<el-option label="审核未通过" :value="2"></el-option>
						</el-select>
					</div>
					<div class="form-item">
						<span class="label">支付状态</span>
						<el-select v-model="queryParams.orderState" placeholder="请选择支付状态" clearable>
							<el-option v-for="item in orderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
					<div class="form-buttons">
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleResetSearch">重置</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="user-center-content">
			<!-- <div v-if="orderList.length" class="btn-group">
				<el-button type="primary" plain @click="handleApplyInoice">
					申请开票
				</el-button>
			</div> -->

			<!-- 订单列表 -->
			<div v-loading="loading" class="order-list">
				<template v-if="orderList.length">
					<div v-for="(order, index) in orderList" :key="index" class="order-item">
						<div class="order-header">
							<div class="order-info">
								<span class="order-no">订单号：{{ order.orderCode }}</span>
								<span class="order-time">下单时间：{{ order.createTime }}</span>
								<span v-if="order.payTime" class="order-time">支付时间：{{ order.payTime }}</span>
							</div>
							<!-- 各种审核状态 -->
							<div class="status-container">
								<div class="order-status" :class="getOrderStateClass(order.orderState)">
									订单状态：{{ getOrderStateName(order.orderState) }}
								</div>
								<div class="audit-status" :class="getMerchantOrderStateClass(order.publicityStyleStatus)">
									审核状态：{{ getMerchantOrderStateName(order.publicityStyleStatus) }}
								</div>
							</div>
						</div>

						<div class="order-content">
							<div class="product-info">
								<div class="product-detail">
									<div class="product-name">{{ order.setMealName }}</div>
									<div class="product-desc">{{ order.eventName }}</div>
								</div>
							</div>
							<div class="price-info">
								<div class="amount">￥{{ order.actualPayment }}</div>
							</div>
						</div>

						<div class="order-footer">
							<!-- 待支付：立即付款 + 取消订单 -->
							<template v-if="isOrderUnpaid(order.orderState)">
								<el-button type="primary" @click="handleOpenPayVouchaer(order)">
									立即付款
								</el-button>
								<el-button @click="handleCancelOrder(order)">取消订单</el-button>
							</template>

							<!-- 已支付状态 -->
							<template v-else-if="isOrderPaid(order.orderState)">
								<!-- 已支付 + 待审批/审核通过：详情 + 发货进度 -->
								<template v-if="isMerchantWaitAudit(order.publicityStyleStatus) || isMerchantPassed(order.publicityStyleStatus)">
									<el-button @click="handleViewDetail(order)">详情</el-button>
									<el-popover
										v-model="order.deliveryProgressVisible"
										placement="left"
										width="360"
										trigger="click"
										popper-class="delivery-progress-popover"
									>
										<delivery-progress-card :order-id="order.id" :visible="order.deliveryProgressVisible" />
										<template #reference>
											<el-button>发货进度</el-button>
										</template>
									</el-popover>
									<el-button v-if="canConfirmReceipt(order)" type="primary" plain @click="handleConfirmReceipt(order)">确认收货</el-button>
								</template>
								<!-- 已支付 + 审核未通过：详情 + 编辑 + 发货进度 -->
								<template v-else-if="isMerchantRejected(order.publicityStyleStatus)">
									<el-button @click="handleViewDetail(order)">详情</el-button>
									<el-button type="primary" plain @click="handleEditOrder(order)">编辑</el-button>
									<el-popover
										v-model="order.deliveryProgressVisible"
										placement="left"
										width="360"
										trigger="click"
										popper-class="delivery-progress-popover"
									>
										<delivery-progress-card :order-id="order.id" :visible="order.deliveryProgressVisible" />
										<template #reference>
											<el-button>发货进度</el-button>
										</template>
									</el-popover>
									<el-button v-if="canConfirmReceipt(order)" type="primary" plain @click="handleConfirmReceipt(order)">确认收货</el-button>
								</template>
							</template>
						</div>
					</div>
				</template>

				<!-- 数据为空 -->
				<empty-content v-else empty-text="暂无订单信息"></empty-content>

				<!-- 分页 -->
				<div v-if="pageOptions.total > pageOptions.limit" class="pagination-container">
					<jr-pagination
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>

		<!-- 上传付款凭证弹窗 -->
		<jr-dialog :visible.sync="payVoucherVisible" width="1400px" :show-btn="false" @close="handlePayClose">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>上传付款凭证</span>
				</h4>
			</template>
			<template slot="content">
				<upload-pay-voucher
					v-if="payVoucherVisible"
					:order-id="curPayOrderId"
					:order-number="curPayOrderNumber"
					@uploadSuccess="handlePaySuccessCallback"
					@uploadCancel="handlePayClose"
				></upload-pay-voucher>
			</template>
		</jr-dialog>

		<!-- 订单详情弹框 -->
		<jr-dialog :visible.sync="showDetailDialog" :show-btn="false" width="1074px" custom-class="order-detail-dialog">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="order-title">
					<span>订单详情</span>
				</h4>
			</template>
			<template v-if="showDetailDialog" slot="content">
				<order-detail :id="selectedOrderId"></order-detail>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import JrPagination from '@/components/Pagination'
	import UploadPayVoucher from '../market/components/uploadPayVoucher.vue'
	import OrderDetail from './components/orderDetail.vue'
	import DeliveryProgressCard from './components/DeliveryProgressCard.vue'
	import { cancelOrder } from '@/api/memberBenefit/index'
	import {
		ENUM_ORDER_STATE,
		ORDER_STATE,
		ORDER_STATE_CLASS,
		ENUM_ORDER_TYPE,
		ENUM_MERCHANT_ORDER_STATE,
		MERCHANT_ORDER_STATE_CLASS,
		MERCHANT_ORDER_STATE
	} from '@/enum/index'
	import { confirmMerchantOrderReceipt, queryMerchantOrderList } from '@/api/mall/index.js'

	export default {
		name: 'ShoppManag',
		components: {
			JrDialog,
			JrPagination,
			UploadPayVoucher,
			OrderDetail,
			DeliveryProgressCard
		},
		props: {},
		data() {
			return {
				// 查询参数
				queryParams: {
					orderCode: '',
					orderType: '',
					orderState: ''
				},
				// 分页配置
				pageOptions: {
					limit: 3,
					page: 1,
					total: 0
				},
				// 加载状态
				loading: false,
				// 订单类型选项
				orderTypes: [],
				// 订单状态选项
				orderStatus: [],
				// 订单列表数据
				orderList: [],

				// 购买会员弹窗
				payVisible: false,
				oldOrderId: '',
				// 上传打款证明弹窗
				payVoucherVisible: false,
				// 当前需付款的订单id
				curPayOrderId: '',
				// 当前需要付款的订单编号
				curPayOrderNumber: '',
				// 订单详情弹窗
				showDetailDialog: false,
				// 选中的订单id
				selectedOrderId: ''
			}
		},
		computed: {},
		watch: {},
		created() {
			// 将ENUM_ORDER_TYPE转给orderTypes
			this.orderTypes = Object.keys(ENUM_ORDER_TYPE).map(key => ({
				label: ENUM_ORDER_TYPE[key],
				value: key
			}))

			// 将ENUM_ORDER_STATE转给orderStatus
			this.orderStatus = Object.keys(ENUM_ORDER_STATE).map(key => ({
				label: ENUM_ORDER_STATE[key],
				value: Number(key)
			}))
		},
		mounted() {
			this.handleGetMyOrderList()
		},
		methods: {
			// 获取订单状态名称
			getOrderStateName(state) {
				return ENUM_ORDER_STATE[state] || '未知状态'
			},

			// 获取订单状态对应的CSS类名
			getOrderStateClass(state) {
				return ORDER_STATE_CLASS[state] || ''
			},

			// 判断订单是否为待支付状态
			isOrderUnpaid(state) {
				return Number(state) === ORDER_STATE.UNPAID
			},

			// 判断订单是否为已支付状态
			isOrderPaid(state) {
				return Number(state) === ORDER_STATE.PAID
			},

			// 判断订单是否为已取消状态
			isOrderCancelled(state) {
				return Number(state) === ORDER_STATE.CANCELLED
			},

			// 判断订单是否为已作废状态
			isOrderAbolish(state) {
				return Number(state) === ORDER_STATE.ABOLISH
			},

			// 判断订单是否为待审核状态
			isOrderWaitAudit(state) {
				return Number(state) === ORDER_STATE.WAITAUDIT
			},

			// 判断审核是否为待审批状态
			isMerchantWaitAudit(state) {
				return Number(state) === MERCHANT_ORDER_STATE.WAITAUDIT
			},

			// 判断审核是否为已通过状态
			isMerchantPassed(state) {
				return Number(state) === MERCHANT_ORDER_STATE.PASSED
			},

			// 判断审核是否为未通过状态
			isMerchantRejected(state) {
				return Number(state) === MERCHANT_ORDER_STATE.REJECTED
			},

			// 判断是否可确认收货：1 已发货，确认后后端更新为 2 已收货
			canConfirmReceipt(order = {}) {
				return Number(order.shippingStatus) === 1
			},

			// 获取企业宣传、风采审核状态名称
			getMerchantOrderStateName(state) {
				return ENUM_MERCHANT_ORDER_STATE[state] || '未知状态'
			},

			// 获取企业宣传、风采审核状态对应的CSS类名
			getMerchantOrderStateClass(state) {
				return MERCHANT_ORDER_STATE_CLASS[state] || ''
			},

			// 查询我的订单
			handleGetMyOrderList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				queryMerchantOrderList(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.orderList = (data.records || []).map(item => ({
								...item,
								deliveryProgressVisible: false
							}))
							this.pageOptions.total = data.total || 0
						} else {
							this.orderList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.orderList = []
						this.pageOptions.total = 0
					})
			},

			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleGetMyOrderList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 3
				this.handleGetMyOrderList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					orderCode: '',
					orderType: '',
					orderState: ''
				}
				this.handleGetMyOrderList()
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				console.log('订单创建成功回调')

				this.payVisible = false
			},

			// 重新选择套餐
			handleResetPackage(order) {
				this.oldOrderId = order.id
				this.payVisible = true
				console.log(this.oldOrderId, 'this.oldOrderId')
			},
			handleCancel() {
				this.oldOrderId = ''
				this.payVisible = false
				console.log(this.oldOrderId, 'this.oldOrderId')
			},

			// 查看详情
			handleViewDetail(order) {
				console.log('查看详情', order)
				this.selectedOrderId = order.id
				this.showDetailDialog = true
			},

			// 编辑订单
			handleEditOrder(order) {
				console.log('编辑订单', order)
				let displaySectorType = ''
				// MERCHANT_ELEGANCEANDCHARM: 企业风采；MERCHANT_PUBLICITY: 企业宣传
				if (order.orderType === 'MERCHANT_PUBLICITY') {
					displaySectorType = '1'
				} else if (order.orderType === 'MERCHANT_ELEGANCEANDCHARM') {
					displaySectorType = '2'
				}
				this.$router.push({
					path: '/mallStore/purchase',
					query: {
						displaySectorType,
						orderId: order.id
					}
				})
			},

			// 取消订单
			handleCancelOrder(order) {
				const data = {
					orderId: order.id
				}

				this.$modal
					.confirm('请确认是否取消该订单？')
					.then(() => {
						return cancelOrder(data)
					})
					.then(() => {
						this.$modal.msgSuccess('订单取消成功')
						this.handleGetMyOrderList()
					})
					.catch(() => {})
			},

			// 确认收货
			handleConfirmReceipt(order) {
				this.$modal
					.confirm('确认已收到该订单服务内容吗？')
					.then(() => {
						return confirmMerchantOrderReceipt({ id: order.id })
					})
					.then(() => {
						this.$modal.msgSuccess('确认收货成功')
						this.handleGetMyOrderList()
					})
					.catch(() => {})
			},

			// 申请开票
			handleApplyInoice() {
				this.$router.push({
					path: '/user/market/order/select'
				})
			},

			// 打开上传打款证明弹窗
			handleOpenPayVouchaer(order) {
				this.curPayOrderId = order.id
				this.curPayOrderNumber = order.orderCode
				this.payVoucherVisible = true
			},

			// 关闭上传打款证明弹窗
			handlePayClose() {
				this.curPayOrderId = ''
				this.curPayOrderNumber = ''
				this.payVoucherVisible = false
			},

			// 上传打款证明成功回调
			handlePaySuccessCallback() {
				this.curPayOrderId = ''
				this.curPayOrderNumber = ''
				this.payVoucherVisible = false
				this.handleGetMyOrderList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';

	.order-list {
		.order-item {
			background: #fff;
			border-radius: 8px;
			margin-bottom: 20px;
			transition: all 0.3s ease;
			border: 1px solid #ebeef5;
			opacity: 0;
			transform: translateY(20px);
			animation: slideUp 0.5s ease forwards;

			@keyframes slideUp {
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			&:hover {
				box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
				transform: translateY(-2px);
			}

			.order-header {
				padding: 10px 20px;
				border-bottom: 1px solid #ebeef5;
				background: #fafafa;
				border-radius: 8px 8px 0 0;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.order-info {
					.order-no {
						font-size: 15px;
						font-weight: 500;
						margin-right: 30px;
					}

					.order-time {
						color: #909399;
						font-size: 14px;

						& + .order-time {
							margin-left: 30px;
						}
					}
				}

				.status-container {
					display: flex;
					justify-content: space-between;
					gap: 10px;
				}

				.order-status {
					padding: 4px 12px;
					border-radius: 15px;
					font-size: 14px;

					&.unpaid {
						color: #e6a23c;
						background: #fdf6ec;
					}

					&.success {
						color: #67c23a;
						background: #f0f9eb;
					}

					&.cancelled {
						color: #909399;
						background: #f4f4f5;
					}

					&.abolish {
						color: #f56c6c;
						background: #fef0f0;
					}

					&.waitaudit {
						color: #e6a23c;
						background: #fdf6ec;
					}
				}
			}

			.audit-status {
				padding: 4px 12px;
				border-radius: 15px;
				font-size: 14px;

				&.passed {
					color: #67c23a;
					background: #f0f9eb;
				}

				&.rejected {
					color: #f56c6c;
					background: #fef0f0;
				}

				&.waitaudit {
					color: #e6a23c;
					background: #fdf6ec;
				}
			}

			.order-content {
				padding: 15px 20px;

				.product-info {
					.product-detail {
						.product-name {
							font-size: 16px;
							color: #303133;
							margin-bottom: 10px;
							font-weight: 500;
							transition: color 0.3s;

							&:hover {
								color: #1374eb;
							}
						}

						.product-desc {
							color: #909399;
							font-size: 14px;
							line-height: 1.6;
						}
					}
				}

				.price-info {
					.amount {
						color: #f56c6c;
						font-size: 22px;
						font-weight: 500;

						// &::before {
						// 	content: '¥';
						// 	font-size: 16px;
						// 	margin-right: 2px;
						// }
					}
				}
			}

			.order-footer {
				padding: 10px 20px;
				border-top: 1px solid #ebeef5;
				text-align: right;
				background: #fafafa;
				border-radius: 0 0 8px 8px;

				.el-button {
					padding: 9px 20px;
					transition: all 0.3s;

					&:hover {
						transform: translateY(-1px);
					}
				}

				/* el-popover 会将 reference 包裹在 span 中，需要兼容处理 */
				> * + * {
					margin-left: 12px;
				}
			}
		}
	}

	.order-detail-dialog {
		box-shadow: 0 8px 24px rgba(39, 80, 140, 0.18);
		border: solid 1px #236fca;
		border-radius: 10px;
		overflow: hidden;
		background-color: #f7f9ff;
		padding: 20px 0;

		.el-dialog__header {
			background: none;

			.order-title {
				margin-bottom: 20px;
				border-bottom: 1px solid #c9c9c9;
				display: flex;
				justify-content: space-between;
				padding-top: 20px;

				span {
					display: block;
					font-size: 20px;
					font-weight: 500;
					color: #333;
					line-height: 1;
					padding: 0 10px;
					padding-bottom: 20px;
					position: relative;
					display: inline-block;

					&::after {
						content: '';
						position: absolute;
						left: 0;
						bottom: -1px;
						width: 100%;
						height: 4px;
						background: #2671cb;
					}
				}
			}

			.el-dialog__headerbtn {
				top: 20px;
				right: 20px;
				background: transparent;
				border-radius: 0;
				font-size: 20px;

				.el-dialog__close {
					color: #1f57c6;
					font-weight: 700;
				}
			}
		}
	}
</style>

<style lang="scss">
	.delivery-progress-popover {
		padding: 0 !important;
		border: solid 1px #236fca;

		.popper__arrow,
		.el-popover__arrow {
			border-left-color: #236fca !important;

			&::after {
				border-left-color: #edf4ff !important;
			}
		}
	}
</style>
